
import { defineComponent, onMounted, reactive, ref } from 'vue';
import PointInfo from '@/components/organisms/point/PointInfo.vue';
import PointInfoExpire from '@/components/organisms/point/PointInfoExpire.vue';
import Coupon from '@/components/organisms/coupon/Coupon.vue';
import SkeltonCoupon from '@/components/organisms/coupon/SkeltonCoupon.vue';
import { useCoupon } from '@/compositions/useCoupon';
import { usePoint } from '@/compositions/usePoint';
import { useRouter } from 'vue-router/composables';

export default defineComponent({
  name: 'PagesExchangeCoupon',

  components: {
    PointInfo,
    PointInfoExpire,
    Coupon,
    SkeltonCoupon,
  },

  setup(_) {
    const { get: getCoupons, outOfStock } = useCoupon();
    const { enabled: pointEnabled, get: getPoint } = usePoint();
    const router = useRouter();

    const state = reactive({
      isLoading: false,
    });

    const coupons = ref<any[]>([]);
    const currentCoupon = ref<object | null>(null);
    const currentPoint = ref<number | null>(null);
    const expiringPoint = ref<number | null>(null);

    const couponRefs = ref<InstanceType<typeof Coupon>[]>();

    const showExchangeConfirmation = (coupon: { id: string }) => {
      currentCoupon.value = coupon;
      router.push(`/exchange_coupon/${coupon.id}/confirm`);
    };

    /**
     * クーポン交換されたら実行される関数
     */
    const onExchange = async () => {
      state.isLoading = true;
      const { coupons: _coupons } = await getCoupons();
      coupons.value = _coupons;
      state.isLoading = false;
    };

    const emptyStockCoupon = (couponId: string) => {
      const coupon = coupons.value.find(v => v.id === couponId);
      coupon.stock = 0;
    };

    const restrictedCoupon = (couponId: string) => {
      console.log(couponId);
      // const coupon = coupons.value.find(v => v.id === couponId);
      // 一覧へ反映したければここで
    };

    onMounted(async () => {
      state.isLoading = true;
      // Point, Coupons取得
      // TODO: 無限スクロール対応、パフォーマンス改善
      const [{ total, endOfMonthTotal }, { coupons: _coupons }] = await Promise.all([getPoint(), getCoupons()]);
      currentPoint.value = total;
      expiringPoint.value = endOfMonthTotal;
      coupons.value = _coupons;
      state.isLoading = false;
    });

    return {
      pointEnabled,
      couponRefs,
      state,
      currentPoint,
      expiringPoint,
      currentCoupon,
      showExchangeConfirmation,
      coupons,
      onExchange,
      outOfStock,
      emptyStockCoupon,
      restrictedCoupon,
    };
  },
});
